<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">选择服务人员</div>
        <el-button type="button" class="btn-close" @click="closeSelf">X</el-button>
      </div>
      <div class="modal-body" style="padding: 10px;">

        <el-row>
          <div style="float:right;">
            <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="getServe">查询</el-button>
          </div>
        </el-row>

        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-table :data="elderlyInfo" style="width: 100%" border :height="400">
              <el-table-column label="姓名" prop="name" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">选择</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>

        <div class="page" style="margin-top: 10px;">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'SelectServe',
  data() {
    return {

      name:'',
      phone:'',
      loading: false,

      elderlyInfo:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',

      th:this.$store.state.tableHeight,

      zoneValue: [],
      zoneCode: '',

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },
  methods: {
    init(){

      this.getServe()

    },
    closeSelf() {
      this.$emit("closeSelectServe");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getServe();
    },
    handleAdd(index, row) {
      this.$emit("setServe",row);
      this.$emit("closeSelectServe");
    },

    getTime(row,index,column){
      return timefilters(column)
    },

    getServe(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          serviceStatus:-1,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.elderlyInfo=response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

  }
}


</script>



